module.exports = __webpack_public_path__ + "img/banner2.91cfa57c.png";